import {PlatformService} from './../../../../services/platform';
import {MembershipService} from './../../profile/membership/membership.service';
import {TabsService} from './../../tabs.service';
import {Component, ElementRef, ViewChild} from '@angular/core';
import {NavParams, Platform, ModalController, NavController, AlertController} from 'ionic-angular';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {ConfirmPage} from './confirm/confirm';
import {CancelPage} from './cancel/cancel';
import {ClassesService} from './../../../../services/classes';
import {SessionService} from '../../../../services/session';
import {StudioPage} from '../studio/studio';
import {LocationsService} from '../../../../services/locations';
import {BackendModule} from '../../../../modules/backend.module';

// pwa/app difference: App uses Ionic native launch navigator

declare var mapboxgl: any;

@Component({
  selector: 'page-class',
  templateUrl: 'class.html'
})
export class ClassPage {

  lesson: any;
  location = {};
  image = [];
  error = false;
  reservationId: void | string = null;
  gym = {};
  hideMapForShowingOnStudio = false;
  future = false;
  now = new Date();
  canCancel = true;
  userRequestedMap = false;
  mapboxURL: string;
  mapboxEnabled = true;

  @ViewChild('mapbox') mapRef: ElementRef;

  constructor(private navParams: NavParams,
              public navCtrl: NavController,
              public platform: Platform,
              public platformService: PlatformService,
              public modalCtrl: ModalController,
              private iab: InAppBrowser,
              public classesService: ClassesService,
              public sessionService: SessionService,
              public tabsService: TabsService,
              public membershipService: MembershipService,
              public alertCtrl: AlertController,
              public locationsService: LocationsService,
              public backendModule: BackendModule,
  ) {
    this.lesson = navParams.get('classInfo');
    const now = new Date();
    const classTime = new Date(this.lesson.schedule.lesson_time)
    this.future = now < classTime;
    this.makeGym();
    this.location = {
      lat: Number(this.lesson.gym.latitude),
      lng: Number(this.lesson.gym.longitude)
    }
  }

  ngOnInit() {
    this.reservationId = this.checkIfClassIsReserved()
    this.image[0] = {image_url: this.lesson.image_url};
    this.testImage(this.image[0].image_url);

  }

  initializeMapBox() {
    const accessToken = this.backendModule.mapBoxToken;
    const lat = Number(this.lesson.gym.latitude);
    const lng = Number(this.lesson.gym.longitude);
    //
    // // const lng =  -99.20698623679992;
    // // const lat = 19.439207196785784;
    const zoom = 15;

    const mapContainer = document.getElementById('map-container');
    setTimeout(() => {
      const mapContainerWidth = mapContainer.offsetWidth || 300;
      const mapContainerHeight = mapContainer.offsetHeight || 300;
      this.mapboxURL = `https://api.mapbox.com/styles/v1/mapbox/streets-v12/static/pin-s+F00(${lng},${lat})/${lng},${lat},${zoom}/${mapContainerWidth}x${mapContainerHeight}?access_token=${accessToken}`
    });
  }

  showMap() {
    this.userRequestedMap = true;

    if (this.mapboxEnabled) {
      setTimeout(() => {
        this.initializeMapBox();
      }, 100);
    }
  }

  ionDidViewEnter() {
  }

  ionViewDidLoad() {
    this.checkCanCancel()
  }


  checkCanCancel() {
    const a = (new Date(this.lesson.schedule.lesson_time));
    const hoursToCancel = this.lesson.schedule.hours_to_cancel || this.membershipService.hoursToCancelClass;
    const b = (new Date((new Date).getTime() + hoursToCancel * 60 * 60 * 1000));
    if (a.getTime() < b.getTime()) {
      this.canCancel = false;
    }
  }

  makeGym() {
    this.lesson.gym.address = this.lesson.gym.adderess;
    this.lesson.gym.services = this.lesson.gym.services;
    if (this.lesson.category_id) {
      this.lesson.gym.categories = [{name: this.classesService.categories[this.lesson.category_id - 1].name}];
    }
  }

  checkIfClassIsReserved() {
    for (var i = 0; i < this.sessionService.reservations.reserved.length; i++) {
      if (this.sessionService.reservations.reserved[i].schedule.id === this.lesson.schedule.id) {
        return this.sessionService.reservations.reserved[i].schedule.reservation.id
      }
    }
    ;
    return null
  }

  testImage(url) {
    var tester = new Image();
    tester.src = url;
    tester.addEventListener('error', () => {
      this.image = [{image_url: './assets/img/god.jpg'}];
    });
  }

  goToLocation() {
    // it should send you in google maps to the location
    window.open(`https://www.google.com/maps/search/?api=1&query=${this.lesson.gym.latitude},${this.lesson.gym.longitude}`, '_system');
  }

  showConfirmModal() {
    if (this.sessionService.hasActiveSubscription() || this.sessionService.isSubscriptionToCancel()) {
      if (this.lesson.gym.pro && !this.sessionService.user.pro) {
        let alert = this.alertCtrl.create({
          // title: "title",
          subTitle:
          this.membershipService.messageToBasicUsers,
          buttons: [
            {
              text: 'Ok',
              role: 'cancel'
            }
          ]
        });
        alert.present();
        // TODO: should alert backend
        return;
      }
      let modal = this.modalCtrl.create(ConfirmPage, {
        lesson: this.lesson,
        canCancel: this.canCancel
      }, {cssClass: 'smaller-modal'});
      modal.onDidDismiss(reservationId => {
        if (reservationId) {
          this.reservationId = reservationId;
        }
        this.checkCanCancel()
      });
      modal.present();
    } else {
      this.membershipService.goToMembership = true;
      this.navCtrl.parent.select(this.tabsService.PROFILE)
    }
  }

  showCancelModal() {
    let modal = this.modalCtrl.create(CancelPage, {
      lesson: this.lesson,
      reservationId: this.reservationId
    }, {cssClass: 'smaller-modal'});
    modal.onDidDismiss(canceled => {
      if (canceled) {
        this.reservationId = null;
      }
    });
    modal.present();
  }


  goToStudio() {
    // need to remove map in order to open map in new page
    this.hideMapForShowingOnStudio = true;
    // for some reason can't open studioPage with map if I dont set a timeout of >=1 ms
    setTimeout(() => {
      this.navCtrl.push(StudioPage, {studioInfo: this.lesson.gym})
    }, 1);
  }

  ionViewWillLeave() {
    this.hideMapForShowingOnStudio = true;
  }

  ionViewWillEnter() {
    this.hideMapForShowingOnStudio = false;
  }


  favorite(studioId) {
    var i = this.sessionService.user.favorite_gyms.indexOf(studioId)
    if (i === -1) {
      this.sessionService.user.favorite_gyms.push(studioId);
    } else {
      this.sessionService.user.favorite_gyms.splice(i, 1)
    }
    console.log(i, this.sessionService.user.favorite_gyms)
    this.backendModule.putAPI(`users/${this.sessionService.user.id}`,
      {user: {favorite_gyms: this.sessionService.user.favorite_gyms}}
    ).subscribe(
      (success) => {
        console.log('Saved', success)
      },
      (err) => {
        this.sessionService.reportError('ClassPage', 'favorite()', err);
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/shared/class/class.ts